import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { err: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State { return { err }; }

  componentDidCatch(err: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', err, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.err) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
          <div className="bg-white border border-red-200 rounded-lg p-6 max-w-lg w-full">
            <h1 className="text-lg font-semibold text-red-700 mb-2">
              Что-то пошло не так
            </h1>
            <p className="text-sm text-slate-600 mb-4">
              Страница упала с ошибкой. Попробуй перезагрузить — состояние в БД
              не пострадало.
            </p>
            <pre className="text-xs bg-slate-100 p-3 rounded overflow-x-auto max-h-40">
              {this.state.err.message}
            </pre>
            <button
              onClick={() => location.reload()}
              className="mt-4 bg-slate-900 text-white rounded px-4 py-2 text-sm"
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
